
export const Email = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_45_60163)">
        <path d="M17.9611 3.33333C17.8854 3.32553 17.809 3.32553 17.7333 3.33333H2.17775C2.07805 3.33487 1.97901 3.34982 1.8833 3.37778L9.91108 11.3722L17.9611 3.33333Z" fill="#E50AAC" />
        <path d="M18.7834 4.10556L10.6945 12.1611C10.4863 12.3681 10.2047 12.4842 9.91115 12.4842C9.61761 12.4842 9.336 12.3681 9.12782 12.1611L1.11115 4.16667C1.08651 4.25724 1.07344 4.35058 1.07227 4.44444V15.5556C1.07227 15.8502 1.18933 16.1329 1.3977 16.3412C1.60608 16.5496 1.88869 16.6667 2.18338 16.6667H17.7389C18.0336 16.6667 18.3162 16.5496 18.5246 16.3412C18.733 16.1329 18.85 15.8502 18.85 15.5556V4.44444C18.8456 4.3287 18.8231 4.21435 18.7834 4.10556ZM2.94449 15.5556H2.17227V14.7611L6.21115 10.7556L6.99449 11.5389L2.94449 15.5556ZM17.7278 15.5556H16.95L12.9 11.5389L13.6834 10.7556L17.7223 14.7611L17.7278 15.5556Z" fill="#E50AAC" />
      </g>
      <defs>
        <clipPath id="clip0_45_60163">
          <rect width="25" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export const EmailGray = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clipRule="evenodd" d="M3 4H21C21.2652 4 21.5196 4.10536 21.7071 4.29289C21.8946 4.48043 22 4.73478 22 5V19C22 19.2652 21.8946 19.5196 21.7071 19.7071C21.5196 19.8946 21.2652 20 21 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4ZM19.031 5.914L12.156 11.414C12.1117 11.4494 12.0567 11.4686 12 11.4686C11.9433 11.4686 11.8883 11.4494 11.844 11.414L4.969 5.914L4.031 7.086L10.907 12.586C11.2173 12.8341 11.6027 12.9693 12 12.9693C12.3973 12.9693 12.7827 12.8341 13.093 12.586L19.969 7.086L19.031 5.914Z" fill="#6B6B6B" />
    </svg>
  )
}

export const EmailBlack = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="black" />
    </svg>
  )
}